import { render, staticRenderFns } from "./TableRelatedRecordsDialog.vue?vue&type=template&id=6364e574&scoped=true"
import script from "./TableRelatedRecordsDialog.vue?vue&type=script&lang=js"
export * from "./TableRelatedRecordsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6364e574",
  null
  
)

export default component.exports